/** 
 * api接口的统一出口
 */

import about from './about';
// 其他模块的接口……
 
// 导出接口
export default {    
    about,
}